<!-- @format -->

<sis-version-selector
  [currentVersionId]="courseUnit?.id"
  [options]="options"
  (change)="onCourseUnitVersionChange($event)"
  [popoverInfoKey]="'STUDIES.COURSE_UNIT_INFO_MODAL.VERSION_POPOVER_INFO'"
  [popoverLabelKey]="'STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_VERSION'"
  [popoverPlacement]="'right'">
</sis-version-selector>
